var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "JadeBox",
        { attrs: { hasPadding: "" } },
        [
          [
            _c("div", { staticClass: "concluded__img--container" }, [
              _c("img", {
                attrs: { src: require(`@/assets/kyc/step_3.svg`).default },
              }),
            ]),
            _c(
              "div",
              { staticClass: "concluded__text--container" },
              [
                _c(
                  "jade-text",
                  { attrs: { weight: "bold", variant: "heading-small" } },
                  [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
                ),
                _c("jade-text", { attrs: { variant: "text-medium" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("subtitle")) + " "),
                ]),
              ],
              1
            ),
            _c(
              "jade-button",
              {
                staticClass: "concluded__button--container",
                attrs: {
                  icon: "device-computer",
                  variant: "primary-solid",
                  size: "medium",
                },
                on: { click: _vm.redirectToHome },
              },
              [_vm._v(" " + _vm._s(_vm.$t("button")) + " ")]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }